import { makeStyles } from '@material-ui/core';
import { colorPalette } from '../../colorPalette';
export const useStyles = makeStyles({
    container: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        padding: '16px 16px 16px 7px',
        boxSizing: 'border-box',
        borderRadius: '4px',
        cursor: 'pointer',
        marginTop: (props) => (props.margins && props.margins.marginTop ? `${props.margins.marginTop}px` : 0),
        marginBottom: (props) => (props.margins && props.margins.marginBottom ? `${props.margins.marginBottom}px` : 0),
    },
    text_container: {
        marginLeft: '3px',
    },
    heading: {
        color: colorPalette.gray900,
        fontWeight: 600,
        lineHeight: '18px',
    },
    description: {
        color: colorPalette.gray800,
        lineHeight: '18px',
        marginTop: '4px',
    },
    default: {
        background: colorPalette.white,
        border: `1px solid ${colorPalette.gray300}`,
    },
    checked: {
        background: colorPalette.gray100,
        border: `1px solid ${colorPalette.gray1000}`,
    },
});
